var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaixa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:none;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width: 2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m5.5,37.3612l12.3334-12.3334h11.3056l-12.3334,12.3334H5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m29.1391,25.0278l6.1667,12.3334h-11.3056l-2.3508-4.7014"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m18.8612,22.9722l-6.1667-12.3334h11.3056l6.1667,12.3334"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m26.398,15.4355l4.7964-4.7964h11.3057l-12.3334,12.3334h-11.3056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaixa);
export default __webpack_public_path__ + "static/media/caixa.1d3541aea3a8e7481f4ed8bd8df5f44f.svg";
export { ForwardRef as ReactComponent };